'use strict';

module.exports = {
  __depends__: [ require(242) ],
  __init__: [ 'lassoTool' ],
  lassoTool: [ 'type', require(175) ]
};
